<template lang="pug">

.tugger
  section.tugger-intro
    AppTitle(:title="$t('mantra')")

    AppLink(to="https://www.npmjs.com/package/tugger" class="button-link is-white" :title="$t('github')") {{$t('github')}}

  section.tugger-features.u-mt-lg
    .grid.is-ultrawide-9.is-widescreen-10.is-desktop-11.is-center
      .column
        h2.u-mb-mi {{$t('features')}}
        .grid.is-tablet-6

          .column.u-mb-sm(v-for="item in $t('featuresItems')")
            h4 {{ item.title }}
            p {{item.desc}}

  section.tugger-install.u-mt-lg
    .grid.is-ultrawide-9.is-widescreen-10.is-desktop-11.is-center
      .column
        h2 {{$t('install')}}

        prism(language="js" :code="install")


  .tugger-rules
    img.tugger-rules-img(src='https://cdn.baianat.com/static/resources/tugger/2.png', srcset='https://cdn.baianat.com/static/resources/tugger/2.png 1x, https://cdn.baianat.com/static/resources/tugger/2@2x.png 2x')

    .grid.is-ultrawide-9.is-widescreen-10.is-desktop-11.is-center
      .column
        .grid.is-tablet-6
          .column.u-mb-sm
            h4 {{$t('rules')}}
            p {{$t('rulesDesc')}}
          .column.u-mb-sm
            h4 {{$t('backend')}}
            p {{$t('backendDesc')}}


  section.tugger-cta
    AppTitle(:title="$t('dragDrop')" tag="h2")
    AppLink(to="https://www.npmjs.com/package/tugger" class="button-link is-white" :title="$t('getStarted')") {{$t('getStarted')}}



  .u-mb-md

</template>
<style lang="stylus">
$clGreen = #00a14f
$clMain = #f22c60

div.app.is-tugger
  overflow: hidden
  background: rgb(183, 242, 7)
  background: linear-gradient(90deg, rgba(183, 242, 7, 1) 0%, rgba(7, 231, 166, 1) 100%)

  .header.is-scroll
    background: $clMain
    color: $clWhite !important

.tugger
  &-intro
    padding-top: unitRes(200, 400)
    padding-bottom: unitRes(120, 240)
    margin-left: -12vw
    margin-right: -12vw
    padding-right: 8vw
    padding-left: 8vw
    z-index: 0
    position: relative
    background-color: $clMain
    background-repeat: no-repeat
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/tugger/1.png')
    background-position: 165% 30%

    +mq($until: 'ultrawide')
      background-size: 70%

    +mq($until: 'tablet')
      background-position: 165% 130%

    +mq($until: 'mobile')
      background-size: 100%

    &-img
      position: absolute
      top: -90%
      right: -45%
      z-index: -1

  &-install
    position: relative
    z-index: 3

  &-rules
    position: relative
    padding: unitRes(100, 300) 0 unitRes(50, 200)

    &-img
      position: absolute
      top: -100px
      left: 0

      +mq($until: 'ultrawide')
        min-width: 1900px
        left: -12vw

      +mq($until: 1500px)
        min-width: 1500px

      +mq($until: 'widescreen')
        left: -30%

      +mq($until: 'tablet')
        left: -90%

  &-cta
    position: relative
    z-index: 2
    background-color: $clMain
    padding: unitRes(20, 160)
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/tugger/3.png')
    background-repeat: no-repeat
    background-position: 120% center
    background-attachment: fixed

html[lang^='ar']
  .tugger
    &-cta
      background-position: -20% center

    &-intro
      background-position: -65% 30%
</style>

<script>
import Prism from '~/components/Prism';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-tugger is-fixedHeader is-whiteHeader',
    logoText: 'logoTuggerTypo',
    logoIcon: 'logoTuggerIcon'
  },

  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),

  components: {
    Prism
  },
  data: () => ({
    install: `npm install tugger
# or use yarn
yarn add tugger`
  })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Tugger",
    "pageDesc":"Tugger is Baianat powerful and easy to install file uploader. It was built to give high performance with various features.",
    "mantra":"Powerful file |uploading tool.",
    "github":"Github",
    "features":"Features",
    "featuresItems":{
      "1":{
        "title":"Different modes:",
        "desc":"Tugger adapts to every context using a variety of modes from basic upload forms to more sophisticated uploaders with controls and queuing."
      },
      "2":{
        "title":"Easy to install and setup",
        "desc":"Including Tugger in your project takes several seconds. Refer to our quick start guide to get instantly started."
      },
      "3":{
        "title":"Drag and Drop Action",
        "desc":"Upload files with ease by just dragging them into Tugger and it will take care of uploading them."
      },
      "4":{
        "title":"Synchronous multiple uploads",
        "desc":"Tugger handles simultaneous file uploading for multiple-file input."
      }
    },
    "install":"Install",
    "rules":"Validation rules",
    "rulesDesc":"Set restrictions on uploaded files using different criteria like size, format and more.",
    "backend":"Backend compatibility",
    "backendDesc":"Tugger works on top of any backend framework like PHP and Node.js",
    "dragDrop":"Drag,drop and let |Tugger handle it.",
    "getStarted":"Get started"
  },
  "ar": {
    "pageTitle":"Tugger",
    "pageDesc":"يمكنك  Tugger من رفع الملفات  تم تصميمه لمنحك أداء عالي لمساعدتك في عملك القادم  مع إمكانية تثبيت وإعداد سهلة.",
    "mantra":"أداة قوية |لرفع الملفات.",
    "github":"غيت هاب",
    "features":"المميزات",
    "featuresItems":{
      "1":{
        "title":"أوضاع مختلفة",
        "desc":"يتكيف Tugger مع كل سياق باستخدام مجموعة متنوعة من الأوضاع، بداية من نماذج الرفع الأساسية وحتى برامج الرفع الأكثر تعقيدًا مع عناصر التحكم و الصفوف."
      },
      "2":{
        "title":"سهل التثبيت والإعداد",
        "desc":"إدراج Tugger في مشروعك لا يستغرق سوى عدة ثوان، ارجع إلى دليل البدء الخاص بنا لاستخدامه على الفور."
      },
      "3":{
        "title":"السحب والإفلات",
        "desc":"يمكنك رفع الملفات بسهولة عن طريق سحبها إلى Tugger وسوف يتولى عملية رفعها."
      },
      "4":{
        "title":"رفع متعدد ومتزامن",
        "desc":"يعالج Tugger رفع الملفات في وقت واحد لادخال ملفات متعددة."
      }
    },
    "install":"التثبيت",
    "rules":"قواعد التحقق",
    "rulesDesc":"يمكنك وضع القيود التى ترغب بها على الملفات التى تقوم برفعها باستخدام معايير مختلفة مثل الحجم والتنسيق والمزيد.",
    "backend":"التوافق مع الجهات الخلفية Backend",
    "backendDesc":"يعمل Tugger مع أي نظام مثل PHP أو Node.js.",
    "dragDrop":"قم بالسحب والإفلات |ثم اترك Tugger يقوم بالتالي.",
    "getStarted":"ابدأ الآن!"
  }
}
</i18n>
